<div class="mat-headline-5">{{ "ONSIP_I18N.TRANSFER_NUMBERS_BETWEEN_PBXS" | translate }}</div>
<form [formGroup]="form">
  <div class="filters-wrapper" onsip-grid-placement-shell-navigation>
    <mat-form-field
      appearance="outline"
      class="first-column"
      onsip-form-field-flush-outline
      onsip-form-field-infix-auto
    >
      <input
        matInput
        formControlName="search"
        [placeholder]="'ONSIP_I18N.SEARCH' | translate"
        autocomplete="off"
      />
      <mat-icon matSuffix color="primary">search</mat-icon>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="second-column"
      onsip-form-field-flush-outline
      onsip-form-field-infix-auto
    >
      <mat-select formControlName="organizationsList" (selectionChange)="onFilterOrganization()">
        @for (option of organizationsFilterList; track option) {
        <mat-option [value]="option">
          {{ option.domain }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="third-column">
      <div class="search">
        <mat-checkbox
          [checked]="
            !!(
              form.controls.selectedElements.value.length === dataSource.filteredData.length &&
              dataSource.filteredData.length &&
              form.controls.selectedElements.value.length
            )
          "
          color="primary"
          class="select-all"
          formControlName="selectAll"
        >
          {{ "ONSIP_I18N.SELECT_ALL" | translate | titlecase }}
        </mat-checkbox>
        <span class="selected-counter-wrapper">
          <span class="mat-body-1"
            >{{ form.controls.selectedElements.value.length }}/{{
              dataSource.filteredData.length
            }}</span
          >
          {{ "ONSIP_I18N.NUMBERS_SELECTED" | translate }}
        </span>
      </div>
    </div>
  </div>
  <onsip-loading-container [deferCond]="isDataObtained$">
    <div class="table-wrapper" onsip-grid-placement-shell-navigation>
      <div class="table-wrapper-container">
        <onsip-table-two
          class="transfer-numbers-table"
          [dataSource]="dataSource"
          multiTemplateDataRows
          [hoverable]="true"
          [useGrid]="true"
          matSort
          matSortDirection="asc"
          matSortActive="pbx"
          [trackBy]="trackById"
        >
          <ng-container matColumnDef="number">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{
              "ONSIP_I18N.NUMBER" | translate
            }}</mat-header-cell>
            <mat-cell *matCellDef="let transferNumber">
              <span class="text-ellipsis">
                <mat-checkbox
                  [checked]="isChecked(transferNumber.number)"
                  color="primary"
                  (change)="setSelectedElements(transferNumber)"
                >
                  {{ transferNumber.number | e164 }}
                </mat-checkbox>
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="pbx">
            <mat-header-cell *matHeaderCellDef mat-sort-header>PBX</mat-header-cell>
            <mat-cell *matCellDef="let transferNumber">
              <span class="text-ellipsis">
                {{ transferNumber.domain }}
              </span>
            </mat-cell>
          </ng-container>
          <mat-header-row
            class="table-headers-row"
            [ngClass]="{ 'with-scroll': dataSource.data.length > 6 }"
            *matHeaderRowDef="displayedColumns$ | async"
          ></mat-header-row>
          <mat-row
            class="table-row"
            [ngClass]="{ 'with-scroll': dataSource.data.length > 6 }"
            *matRowDef="let row; columns: displayedColumns$ | async"
          ></mat-row>
          <div *matNoDataRow class="no-data-row">
            {{ "ONSIP_I18N.NO_RESULTS" | translate }}
          </div>
        </onsip-table-two>
      </div>
    </div>
  </onsip-loading-container>
</form>
<div class="page-controls-wrapper">
  <button mat-flat-button color="primary" type="button" (click)="openTransferDidsModal()">
    {{ "ONSIP_I18N.TRANSFER_NUMBERS" | translate }}
  </button>
</div>
